export interface DisoAccount {
  tenantID: string;
  masterTenantID: string;
  brandName: string;
  masterBrandName: string;
  mainContactObjId: string | null;
  mainContactEmail: string;
  mainContactFullName: string | null;
  ownerEmail: string;
  ownerFullName: string | null;
  mainDomain: string;
  cmdisoSubscription?: DisoSubscription[];
  myCMDISOAccountStatus: CMDISOAccountStatusEnum;
  marketingResourceExternalId: string | null;
  active: boolean;
  cmid: string;
  additionalDomains: any[];
  name: string | null;
  description: string | null;
  comments: string | null;
  dateCreated: string;
  createdByUserID: string;
  ownerID: string;
  id: number;
  deletionState?: string | null;
  deletionSummary?: string | null;
  deletionWorkflowId?: string | null;
}
export interface DisoSubscription {
  active: boolean;
  cmid: string;
  comments: string | null;
  createdByUserID: string;
  dateCreated: string;
  description: string | null;
  id: number;
  masterTenantID: string;
  myCMSubscriptionType: number;
  name: string | null;
  numberOfDISOSubscriptions: number | null;
  numberOfDISOUsedSubscription: number | null;
  ownerID: string | null;
  programID: string | null;
  subscriptionEnd: string | null;
  subscriptionStart: string | null;
  tenantID: string;
  [key: string]: any | null;
}

export interface CreateDisoAccount {
  BrandName?: string;
  MainContactEmail?: string;
  OwnerEmail?: string;
  MainDomain?: string;
  SendInvitation?: boolean;
  AllowUsersFromAnyDomain?: boolean;
  AdditionalDomains?: string[];
  TenantID?: string;
  /** Tenant default language (en|he|ar). Server defaults omitted/null/empty to en. */
  DefaultLanguageCode?: string;
  //RegionID:string//int
}

export enum CMDISOAccountStatusEnum {
  NEW = 0,
  NEED_REGISTRATION = 1,
  REGISTRATION_SENT_TO_USER = 2,
  REGISTERED = 3,
  ON_BOARDING = 4,
  PROFILE = 5,
  PROGRAM = 6,
  FREEZED = 7,
  TO_REMOVE = 8,
  REMOVED = 9,
  PROVISIONING_FAILED = 10,
}

export enum DisoAccountDeletionState {
  REQUESTED = 'DeletionRequested',
  IN_PROGRESS = 'DeletionInProgress',
  RETRY_PENDING = 'DeletionRetryPending',
  FAILED = 'DeletionFailed',
}

export interface DisoAccountDeletionStatus {
  workflowId: string;
  state: DisoAccountDeletionState;
  operatorSummary: string;
  retryAllowed: boolean;
  currentStage: string | null;
}

export interface AddNewDisoSubscriptionRequest {
  tenantID: string;
  subscriptionStart: string;
  lengthOfSubscription: number;
  numberOfDISOSubscriptions: number;
}
